import { SVG_xcircle } from '../elements/SVG';

export default function Input({ label = false, ref, type, error, ...other }) {
    const { id = false } = other;
    return (
        <div className={`e-form${error ? ' e-form--error' : ''} e__form__item${error ? ' rrr' : ''}`}>
            {label && <label htmlFor={id}>{label}</label>}
            <div className="e-form__wrapper">
                <span className="e-form__input">
                    <input
                        id={id}
                        ref={ref}
                        type={type}
                        {...other}
                    />
                </span>
            </div>
            {error && error !== 'unknown' && (
                <span className="e__txt__error">{error}</span>
            )}
            {error && (
                <span className="e__form__item__ico">
                    <SVG_xcircle />
                </span>
            )}
        </div>
    );
}
